import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useSetTrustedUser = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload) => api.users.setUserTrusted(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userCard'] })
    },
    onError: (err: any) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка смены статуса лимита',
        description: err.response?.data?.message || err.message,
      })
    },
  })
}
